import type { ActionPlanInternalLinkRow } from './api-types';
import type { PlanV2IssueDispositionRecord } from './plan-v2-issues';

/** Issues / work items: only incoming links (edit on other pages pointing at this URL). */
export function isInternalLinkIncomingToPage(
  row: ActionPlanInternalLinkRow,
  pageUrlId: string
): boolean {
  const id = (pageUrlId || '').trim();
  return row.status === 'open' && !!id && row.targetUrlId === id;
}

export function filterInternalLinksIncomingToPage(
  rows: ActionPlanInternalLinkRow[],
  pageUrlId: string
): ActionPlanInternalLinkRow[] {
  const id = (pageUrlId || '').trim();
  if (!id) return [];
  return rows.filter((row) => isInternalLinkIncomingToPage(row, id));
}

export function internalLinkSuggestionKeyFromIssueKey(issueKey: string): string {
  const parts = (issueKey || '').split(':');
  if (parts.length < 3 || parts[1] !== 'internal_link') return '';
  return parts.slice(2).join(':').trim();
}

export function internalLinkSuggestionKeysInWorkItems(
  records: Map<string, PlanV2IssueDispositionRecord> | Iterable<PlanV2IssueDispositionRecord>
): Set<string> {
  const keys = new Set<string>();
  const values = records instanceof Map ? records.values() : records;
  for (const record of values) {
    if (record.issueType !== 'internal_link' || record.queue !== 'work_item') continue;
    const suffix =
      internalLinkSuggestionKeyFromIssueKey(record.issueKey) || (record.suggestionKey || '').trim();
    if (suffix) keys.add(suffix);
  }
  return keys;
}

/** Incoming links still triaged on the beneficiary Issues card (not already in Work items). */
export function filterInternalLinksPendingIssuesTriage(
  rows: ActionPlanInternalLinkRow[],
  pageUrlId: string,
  inWorkItems: Set<string>
): ActionPlanInternalLinkRow[] {
  return filterInternalLinksIncomingToPage(rows, pageUrlId).filter((row) => !inWorkItems.has(row.suggestionKey));
}
